import { SolarSchoolsTheme } from "./utilities/Theme/theme";
import { ThemeProvider } from "@material-ui/core/styles";
import { SchoolProfileView } from "./SchoolProfileView";
import ReactDOM from "react-dom";
import React from "react";

const init = async (api) => {
  const element = document.getElementById("school-profile");

  if (!element) {
    return;
  }

  // build API URL from slug and URL
  // NOTE: Not ideal incase routing changes but it works
  const url = window.location.href.split("schools/");
  const slug = url[1];

  try {
    const school = await api.call("schemas", "getResourceBySlug", [
      1,
      slug,
      "",
      true,
      true,
    ]);
    // render to react and update the page title
    document.title = `${school.resourceName ||
      "School Profile"} - Solar Schools`;
    ReactDOM.render(
      <ThemeProvider theme={SolarSchoolsTheme}>
        <SchoolProfileView
          school={school}
          resourceType={school.resourceType}
          api={api}
        />
      </ThemeProvider>,
      element
    );
  } catch (err) {
    console.error(err);
  }
};

export default init;



// WEBPACK FOOTER //
// ./resources/assets/js/app/schoolProfile.js